import { Modal } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";
import UpdateProfileForm from "./updateProfileForm";

type UpdateUserProfileModalProps = {
  opened: boolean;
  onClose: () => void;
  userId?:string
};

function UpdateUserProfileModal({
  opened,
  onClose,
  userId
}: UpdateUserProfileModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="md"
      withCloseButton={false}
      transitionDuration={300}
      centered
      size="50%"
      overflow="inside"
    >
      <ModalHeader
        title="Update Profile"
        onClose={onClose}
        ariaLabel="Close update profile modal"
      />

      <UpdateProfileForm onClose={onClose} userId={userId} />
    </Modal>
  );
}

export default UpdateUserProfileModal;
